class GeocodingItem {
   constructor(params) {
      // координаты точки
      this.position = params.position || [0, 0];

      // координаты описывающего прямоугольника
      let lowerCorner = params.leftCorner || [0, 0];
      let upperCorner = params.upperCorner || [0, 0];

      let extent = {lowerCorner: lowerCorner, upperCorner: upperCorner};
      this.extent = extent;

      // описание найденного геообъекта
      this.address = params.address || params.text || "";

      // точность соответствия поиска
      this.precision = params.precision || undefined;
      this.kind = params.kind || undefined;
   }
}

module.exports = GeocodingItem;